import { useGlobalContext } from '~/context/GlobalContext';
import { useState, useEffect, useRef } from 'react'; // Dodano useEffect i useRef
import { IChatRoom, IUser } from '~/types/common';
import Avatar from '~/components/PrivateChatContainer/Avatar';
import classNames from 'classnames';
import { useViewportResize } from '~/hooks/useViewportResize';
import { UserIcon } from '../Icons/Icons';
import styles from './PrivateChatContainer.module.css';

function PrivateChatContainer() {
  const { context, setContext } = useGlobalContext();
  const [isOpen, setIsOpen] = useState(false);
  const resize = useViewportResize();

  // Ref do wykrywania kliknięć poza kontenerem
  const containerRef = useRef<HTMLDivElement>(null);

  // --- LOGIKA ZAMYKANIA POZA OBSZAREM ---
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent | TouchEvent) => {
      if (
        isOpen &&
        containerRef.current &&
        !containerRef.current.contains(event.target as Node)
      ) {
        setIsOpen(false);
      }
    };

    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
      document.addEventListener('touchstart', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      document.removeEventListener('touchstart', handleClickOutside);
    };
  }, [isOpen]);

  const getStorageData = () => {
    const storedData = window.sessionStorage.getItem('user');
    return storedData ? JSON.parse(storedData) : null;
  };

  const handlePrivateChatClick = (room: IChatRoom) => {
    setContext(prev => ({
      ...prev,
      activeSidebarId: '',
      room: room,
      rooms: prev.rooms.map(r => r.id === room.id ? { ...r, unreadCount: 0 } : r)
    }));
    setIsOpen(false); // Zamykamy listę po wyborze pokoju
  };

  const privateRooms = context.rooms.filter(room => !room.public && room.users);
  if (privateRooms.length === 0) return null;

  return (
    <div
      ref={containerRef}
      data-component="PrivateChatContainer"
      className={classNames(styles.privateChatContainer, {
        [styles.openContainer]: isOpen
      })}
      style={{
        transform: resize.isKeyboardOpen
          ? `translateY(${(resize.initialHeight ?? resize.height) - resize.height}px)`
          : 'translateY(0)'
      }}>
      {/* Lista wysuwana */}
      <div className={classNames(styles.avatarList, { [styles.listOpen]: isOpen })}>
        {privateRooms.map((room: IChatRoom, idx: number) => {
          const me: IUser = getStorageData();
          const otherUser: IUser | undefined = room.users?.find(u => u.id !== me?.id);
          if (!otherUser) return null;

          return (
            <div
              key={room.id || idx}
              className={styles.avatarItem}
              onClick={() => handlePrivateChatClick(room)}>
              <div className={styles.avatarWrapper}>
                <Avatar user={otherUser} room={room} isShow={isOpen} />
              </div>
              <div className={styles.avatarName}>{otherUser.name}</div>
            </div>
          );
        })}
      </div>

      {/* Przycisk przełącznika */}
      <button
        className={styles.toggleBtn}
        onClick={() => setIsOpen(!isOpen)}
      >
        <UserIcon />
        {!isOpen && (
          (() => {
            const totalPrivateUnread = context.rooms.reduce((acc, r) => {
              if (!r.public) return acc + (r.unreadCount || 0);
              return acc;
            }, 0);

            return totalPrivateUnread > 0 ? (
              <div className={styles.globalNotify}>
                {totalPrivateUnread > 99 ? '99+' : totalPrivateUnread}
              </div>
            ) : null;
          })()
        )}
      </button>
    </div>
  );
}

export default PrivateChatContainer;